/**
 * @param {string} agentId
 * @param {'guild'|'world'} scope
 * @param {'week'|'all'} period
 */
export function leaderboardPath(agentId, scope, period) {
  return `/api/voko/agents/${encodeURIComponent(agentId)}/leaderboard?scope=${scope}&period=${period}`
}
